import isAfter from "date-fns/isAfter";

export const isInternalIP = (ipaddress) => {
	// internal ip addresses include:
	// 172.* (reserved internal), 104.129.192.0 - 104.129.207.255 (ZScaler - might not be all T. Rowe)
	const ipRegEx = /((^172\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(^104\.129\.19[2-9]\.[0-9]{1,3})|(^104\.129\.20[0-7]\.[0-9]{1,3}))/;

	return ipaddress.match(ipRegEx);
};

// check date
export const showApp = (date) => {
	// check date
	const currentDate = new Date();
	const startDate = new Date(date);

	return isAfter(currentDate, startDate);
};

// getTimestamp
export const getTimestamp = () => {
	return new Date();
};

export const isInternalDomain = () => {
	const isInternal =
		window.location.href.indexOf("awstrp.net") > 0 ? true : false;

	return isInternal;
};
